import React from 'react'
import { IntrigrationSec } from './intrigrationSec'

export const IntrigrationCreditCard = () => {
  return (
    <>
    <IntrigrationSec /> 
    </>
  )
}
